export default __webpack_public_path__ + "static/media/placeholder-alloy-wheel.67a6c0f8.png";